// convert string from snake_case to camelCase
const snakeToCamel = (str = '') => str.replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''));

// clones snakecase keyed properties with camelCase keyed properties
export default function cloneSnakeCaseProperties(acc, [key, value]) {
  acc[key] = value;
  if (key.includes('-') || key.includes('_')) {
    acc[snakeToCamel(key)] = value;
  }
  return acc;
}